import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApolloProvider, graphqlClient as defaultClient, } from '@biscuits/graphql';
import { createContext, useContext } from 'react';
import { AppPreviewNotice } from '../apps/AppPreviewNotice.js';
import { Essentials } from '../apps/Essentials.js';
import { VerdantContext } from '../verdant.js';
import { GlobalSyncingIndicator } from './GlobalSyncingIndicator.js';
import { PrereleaseWarning } from './PrereleaseWarning.js';
import { TopLoader } from './TopLoader.js';
export function Provider({ graphqlClient = defaultClient, appId, children, verdantClient = null, disablePreviewWarning, router, }) {
    return (_jsx(ApolloProvider, { client: graphqlClient, children: _jsx(BiscuitsContext.Provider, { value: { appId }, children: _jsxs(VerdantContext.Provider, { value: verdantClient, children: [appId && _jsx(AppPreviewNotice, {}), appId && !disablePreviewWarning && _jsx(PrereleaseWarning, {}), _jsx(TopLoader, { router: router }), verdantClient && _jsx(GlobalSyncingIndicator, {}), children, _jsx(Essentials, {})] }) }) }));
}
const BiscuitsContext = createContext(null);
export function useAppId() {
    const ctx = useContext(BiscuitsContext);
    if (!ctx) {
        throw new Error('useAppId must be used within a BiscuitsProvider');
    }
    if (!ctx.appId) {
        throw new Error('Cannot use useAppId in a non-app context');
    }
    return ctx.appId;
}
export function useMaybeAppId() {
    const ctx = useContext(BiscuitsContext);
    return ctx === null || ctx === void 0 ? void 0 : ctx.appId;
}
//# sourceMappingURL=Context.js.map